import React from 'react'
import { useTranslation } from 'react-i18next'
import DOMPurify from 'dompurify'
import { convertToSimpleDate } from '../../utils/filters/date'
import './firmware-release-notes.scss'

const ReleaseNotes = (props) => {
  const { t } = useTranslation()
  const { selectedDevice } = props
  const latestVersion = selectedDevice?.versions[0]

  const hasValidNotes = (notes) => {
    return notes && notes.length > 0 && notes !== '<p></p>' && notes !== '<p><br></p>'
  }

  return (
    <div className="firmware-release-notes-wrapper">
      <div className="product-name-latest">{latestVersion?.name}</div>
      <div className="label-date">
        <span>{t('uploaded')}: </span>
        {convertToSimpleDate(latestVersion?.created_at)}
      </div>
      <div className="release-notes">
        {hasValidNotes(latestVersion?.release_notes?.admin_note) && (
          <div>
            <p className="section-name">{t('admin_notes')}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(latestVersion?.release_notes?.admin_note),
              }}
            />
          </div>
        )}
        {hasValidNotes(latestVersion?.release_notes?.admin_note) && hasValidNotes(latestVersion?.release_notes?.tech_note) && <div className="separator" />}
        {hasValidNotes(latestVersion?.release_notes?.tech_note) && (
          <div>
            <p className="section-name">{t('tech_notes')}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(latestVersion?.release_notes?.tech_note),
              }}
            />
          </div>
        )}
        {(hasValidNotes(latestVersion?.release_notes?.admin_note) || hasValidNotes(latestVersion?.release_notes?.tech_note)) &&
          hasValidNotes(latestVersion?.release_notes?.user_note) && <div className="separator" />}
        {hasValidNotes(latestVersion?.release_notes?.user_note) && (
          <div>
            <p className="section-name">{t('user_notes')}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(latestVersion?.release_notes?.user_note),
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ReleaseNotes
